import React, { Component } from "react";
import FormStyle from "./FormStyle";
import { withTranslation } from "react-i18next";

class ContactTwo extends Component {
  render() {
    const { i18n } = this.props;
    // Check the current language
    const isEnglish = i18n.language === "en";

    return (
      <div className="contact-form--1">
        <div className="container">
          <div className="row row--35 align-items-start">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="section-title text-left mb--50">
                <span className="subtitle">{isEnglish ? "Let's Connect" : "Let's Connect"}</span>
                <h2 className="title">
                {isEnglish ? "Contact With Us." : "Contactez-nous."}
                  </h2>
              </div>
              <FormStyle />
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="thumbnail mb_md--30 mb_sm--30">
                <iframe
                  className="mb-4 mb-lg-0"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13501.929963921208!2d-7.9356577!3d32.2181727!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xbd50c8e7902ffbf9!2sUniversit%C3%A9%20Mohammed%20VI%20Polytechnique!5e0!3m2!1sfr!2sma!4v1608379187309!5m2!1sfr!2sma"
                  frameBorder="0"
                  style={{ border: 0, width: "100%", height: "500px" }}
                  allowFullScreen=""
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(ContactTwo);
